import axios from "axios";
import React, { useState, useEffect } from "react";
import cloud from "../../src/img/1.png";
import run from "../../src/img/2.png";
import {
  Row,
  Col,
  Button,
  Divider,
  Tooltip,
  Modal,
  Image,
} from "antd";
import { TweenOneGroup } from "rc-tween-one";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import { getChildrenToRender } from "./utils";
import "./less/appList.less";

function AppListComponent() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkItem, setCheckItem] = useState({});
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const titleList = {
    className: "title-wrapper",
    children: [
      { name: "title", children: "产品", className: "title-h1" },
      {
        name: "content",
        className: "title-content",
        children: "",
      },
    ],
  };
  const [appDataList, setAppDataList] = useState({
    className: "applist-img-wrapper",
    gutter: 16,
    children: [
    ],
  });
  const getAppDataList = () =>
    new Promise((resolve, reject) => {
      let arr = [
        {
          name: "block1",
          className: "block",
          md: 6,
          xs: 24,
          justify: "center",
          children: {
            wrapper: { className: "applist-block-content" },
            img: {
              children: cloud,
            },
            // content: { children: e.productName },
            // appTip: {
            //   children: e.productDesc,
            //   className: "applist-block-appTip",
            // },
            // downLoadUrl: e.downloadUrl,
            // productImgs: e.productImgs,
          },
        },
        {
          name: "block2",
          className: "block",
          md: 6,
          xs: 24,
          children: {
            wrapper: { className: "applist-block-content" },
            img: {
              children: run,
            },
            // content: { children: e.productName },
            // appTip: {
            //   children: e.productDesc,
            //   className: "applist-block-appTip",
            // },
            // downLoadUrl: e.downloadUrl,
            // productImgs: e.productImgs,
          },
        }
      ]
      setAppDataList({
        className: "applist-img-wrapper",
        gutter: 16,
        children: arr,
      });
      return
      let domain = window.location.host;
      if (domain.indexOf("www.") === -1) {
        domain = "www." + domain;
      }
      axios({
        url: "https://edc.vigame.cn:6115/website/getProductList",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: { domain: "www.iniflow.cn" },
        // data: { domain },
      })
        .then((e) => {
          if (e.status) {
            const { data } = e;
            if (data.ret === 1) {
              let arr = data.data.map((e, i) => {
                console.log(
                  getAppDetailImgs({
                    wrapper: { className: "applist-block-content" },
                    img: {
                      children: e.icon,
                    },
                    content: { children: e.productName },
                    appTip: {
                      children: e.productDesc,
                      className: "applist-block-appTip",
                    },
                    downLoadUrl: e.downloadUrl,
                    productImgs: e.productImgs,
                  })
                );

                return {
                  name: "block" + i,
                  className: "block",
                  md: 6,
                  xs: 24,
                  children: {
                    wrapper: { className: "applist-block-content" },
                    img: {
                      children: e.icon,
                    },
                    content: { children: e.productName },
                    appTip: {
                      children: e.productDesc,
                      className: "applist-block-appTip",
                    },
                    downLoadUrl: e.downloadUrl,
                    productImgs: e.productImgs,
                  },
                };
              });
              setAppDataList({
                className: "applist-img-wrapper",
                gutter: 16,
                children: arr,
              });
              resolve(data.data);
            }
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    });

  const getAppChildrenToRender = (data) =>
    data.map((item) => {
      return (
        <Col
          key={item.name}
          {...item}
          // onClick={() => {
          //   setIsModalOpen(true);
          //   setCheckItem(item.children);
          // }}
        >
          <a {...item.children.wrapper}>
            <span {...item.children.img}>
              <img src={item.children.img.children} height="100%" alt="img" />
            </span>
            {/* <p {...item.children.content}>{item.children.content.children}</p> */}
            {/* <Tooltip title={item.children.appTip.children}>
              <p {...item.children.appTip}>{item.children.appTip.children}</p>
            </Tooltip> */}
            {/* {item.children.downLoadUrl ? <Divider /> : <></>} */}
            {/* {item.children.downLoadUrl ? (
              <Button
                style={{ marginBottom: "10px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  item.children.downLoadUrl &&
                    window.open(item.children.downLoadUrl);
                }}
              >
                安卓下载
              </Button>
            ) : (
              <></>
            )} */}
          </a>
        </Col>
      );
    });
  const childrenToRender = getAppChildrenToRender(appDataList.children);
  const getAppDetailImgs = (item) => {
    if (!item.productImgs) return <></>;
    let imgsDom = [];
    item.productImgs.split(",").map((e, i) => {
      return imgsDom.push(
        <div key={i} style={{marginTop: "10px"}}>
          <Image width={208} height={370} className="applist-modal-imgsItem" src={e} />
        </div>
      );
    });
    return imgsDom;
  };

  useEffect(() => {
    getAppDataList();
  }, []);
  return (
    <>
      {appDataList.children.length ? (
        <>
          <div id="appList" className="home-page-wrapper applist-wrapper">
            <div className="home-page applist">
              <div key="title" className="title-wrapper">
                {titleList.children.map(getChildrenToRender)}
              </div>
              <OverPack className={`content-template`} playScale={0.3}>
                <TweenOneGroup
                  component={Row}
                  key="ul"
                  enter={{
                    y: "+=30",
                    opacity: 0,
                    type: "from",
                    ease: "easeInOutQuad",
                  }}
                  leave={{ y: "+=30", opacity: 0, ease: "easeInOutQuad" }}
                  {...appDataList}
                >
                  {childrenToRender}
                </TweenOneGroup>
              </OverPack>
              <Modal
                width="70%"
                open={isModalOpen}
                footer={null}
                onCancel={handleCancel}
              >
                {Object.keys(checkItem).length && (
                  <Row style={{ paddingTop: "20px" }}>
                    <Col span={5} className="applist-modal-detail">
                      <span {...checkItem.img}>
                        <Image
                          src={checkItem.img.children}
                          height="120px"
                          width="120px"
                          alt="img"
                        />
                      </span>
                      <p {...checkItem.content} className="applist-modal-title">
                        {checkItem.content.children}
                      </p>
                      <Tooltip title={checkItem.appTip.children}>
                        <p {...checkItem.appTip} className="applist-modal-tip">
                          {checkItem.appTip.children}
                        </p>
                      </Tooltip>
                      {checkItem.downLoadUrl ? <Divider /> : <></>}
                      {checkItem.downLoadUrl ? (
                      <Button
                          style={{ marginBottom: "10px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            checkItem.downLoadUrl &&
                              window.open(checkItem.downLoadUrl);
                          }}
                        >
                          安卓下载
                        </Button>
                      ) : (
                        <></>
                      )}
                    </Col>
                    <Col span={1}></Col>
                    <Col span={17}>
                      <div className="applist-modal-imgs">
                        {getAppDetailImgs(checkItem)}
                      </div>
                    </Col>
                  </Row>
                )}
              </Modal>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default AppListComponent;
